<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>To Catch a Thief</title>
<link href="pdlmsr.css" rel="stylesheet" type="text/css"/>
<meta content="text/html; charset=UTF-8"/>
<link href="page-template.xpgt" rel="stylesheet" type="application/vnd.adobe-page-template+xml"/>
<div class="adCardPage" id="adp"><h2 class="adCardHead"><span class="bold"><span>Also available from<br/>
<span class="bold1"><span>CHRISTINA SKYE</span></span><br/>
and HQN Books</span></span></h2><p class="adCardSubhead"><span><span class="bold"><span>Code Name</span></span></span></p><p class="adCardText"><span><em class="italic"><span>Code Name: Bikini</span></em></span></p><p class="adCardText"><span><em class="italic"><span>Code Name: Blondie</span></em></span></p><p class="adCardText"><span><em class="italic"><span>Code Name: Baby</span></em></span></p><p class="adCardSubhead"><span><span class="bold"><span>Draycott Abbey</span></span></span></p><p class="adCardText"><span><em class="italic"><span>Draycott Eternal</span></em></span></p><p class="adCardText"><span><em class="italic"><span>The Draycott Legacy</span></em></span></p><p class="adCardSubhead"><span><span class="bold"><span>And coming in winter 2009</span></span></span></p><p class="adCardText"><span><em class="italic"><span>Christmas Knight</span></em></span></p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tocatchathief_adp.vue?1ca616c3